import React, { useState } from 'react';
import { RequetesAnalytics } from './RequetesAnalytics';
import { PermisGerer } from './PermisGerer';
import { PermisConfigurer } from './PermisConfigurer';
import { useLanguage } from '../contexts/LanguageContext';
import { useScreenInit } from '../useScreenInit.js';
export function PermisModule() {
  const screenInit = useScreenInit();
  const {
    t
  } = useLanguage();
  const [activeSubTab, setActiveSubTab] = useState(screenInit.activeSubTab ?? 'gerer');
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-4669" data-mp="3tiyjtbs8x7j6">
      {/* Page Title & Navigation */}
      <div className="mb-8" data-id="element-4670" data-mp="bdlhpjitho3k">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6" data-id="element-4671" data-mp="bdvafev8y9cy">
          <h1 className="text-2xl font-bold text-[#0F172A] font-heading" data-id="element-4672" data-mp="7ap7ag3fkyap">
            {activeSubTab === 'analytiques' ? t('Permis Analytics', 'Permits Analytics') : t('Permis', 'Permits')}
          </h1>
          <nav aria-label="Actions" className="flex items-center gap-2" data-id="element-4673" data-mp="1isq7x8fetlir">
            <button onClick={() => setActiveSubTab('gerer')} className={`px-4 py-2 text-sm font-semibold rounded-lg transition-colors ${activeSubTab === 'gerer' ? 'text-white bg-[#0F172A] shadow-sm hover:bg-[#1E293B]' : 'text-slate-600 bg-white border border-slate-200 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-4674" data-mp="1y1hms6irch6q">
              {t('Gérer', 'Manage')}
            </button>
            <button onClick={() => setActiveSubTab('analytiques')} className={`px-4 py-2 text-sm font-semibold rounded-lg transition-colors ${activeSubTab === 'analytiques' ? 'text-white bg-[#0F172A] shadow-sm hover:bg-[#1E293B]' : 'text-slate-600 bg-white border border-slate-200 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-4675" data-mp="1fdcovfos7qfu">
              {t('Analytiques', 'Analytics')}
            </button>
            <button onClick={() => setActiveSubTab('configurer')} className={`px-4 py-2 text-sm font-semibold rounded-lg transition-colors ${activeSubTab === 'configurer' ? 'text-white bg-[#0F172A] shadow-sm hover:bg-[#1E293B]' : 'text-slate-600 bg-white border border-slate-200 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-4676" data-mp="10mlvi37jkjam">
              {t('Configurer', 'Configure')}
            </button>
          </nav>
        </div>
      </div>

      {activeSubTab === 'analytiques' ? <RequetesAnalytics data-id="element-4677" data-mp="1ky59pbkbwubn" /> : activeSubTab === 'configurer' ? <PermisConfigurer data-id="element-4678" data-mp="1l0hzuc08qazs" /> : <PermisGerer data-id="element-4679" data-mp="1g0c7suq26mh6" />}
    </div>;
}